import {randomFromArray} from '../../../helpers/random-from-array.js'
import {getSelfServingTeamOrder} from '../get-sorted-by-self-serving'

export function getRecoverPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {


  //First check for revival moves
  const deadTeammateWithRevivalMoveMatch = getValidRevivalMovesAndTarget(casterActions, teamCombatants);
  if (deadTeammateWithRevivalMoveMatch) {
    //We can revive somebody, so stop here with that:
    return {
      actionModel: deadTeammateWithRevivalMoveMatch.actionModel,
      casterModel: casterModel,
      targetModels: [deadTeammateWithRevivalMoveMatch.targetModel]
    }
  }


  //Now see if we have valid recovery moves
  const validMoves = getValidRecoverMoves(casterActions);
  if (!validMoves.length) {
    // console.log('no length')
    return null
  }

  //Choose a valid ALIVE person to recover (uses selfServing)
  const targetModel = confirmRecoveryTarget(
    getSelfServingTeamOrder( casterModel, teamCombatants.filter(model => model.isAlive()) )
  );

  //Return a random one of our valid moves
  if (targetModel) {
    const actionModel = randomFromArray(validMoves);
    return {
      actionModel: actionModel,
      casterModel: casterModel,
      targetModels: [targetModel]
    }
  }

  return null
}



function confirmRecoveryTarget(remainingTargets) {

  //check the first in the list
  const candidate = remainingTargets[0];
  const candidateHpPercent = candidate.hp / candidate.maxHp * 100;

  if (candidateHpPercent <= 75) {
    return candidate
  }

  if (remainingTargets.length > 1) {
    return confirmRecoveryTarget( remainingTargets.filter((d,i) => i > 0 )); //run again without the 0th entry
  }

  //nobody is valid
  return null
}


function getValidRecoverMoves(casterActions) {
  //TODO: No recovery special attacks exist yet. Only items.

  //TODO: make sure PP is validating before returning a recovery attack as an option.

  const validMoves = casterActions.filter(action => {
    return action.affectTargetHpPoints > 0 && !action.targetMustBeDead //Moves that affect hp to greater values. No revival items! Only ones for alive people
  });
  //TODO: sort isItem actions to be last in the array (so we don't hog the items when we could just use an attack)
  //TODO 2: are we sure about that?
  return validMoves;
}

/** Get back a valid pair of Revival move / dead combatant */
function getValidRevivalMovesAndTarget(casterActions, combatantsList) {
  //TODO: No recovery revival special attacks exist yet.

  //First check that any combatants are dead
  const deadCombatants = combatantsList.filter(comb => !comb.isAlive());

  //Nobody is dead, so bail here
  if (!deadCombatants.length) {
    return null;
  }

  //Do we have any revival moves?
  const revivalActions = casterActions.filter(action => {
    return action.targetMustBeDead && action.affectTargetHpPointsByPercent > 0
  });

  //No revival moves, so bail here
  if (!revivalActions.length) {
    return null;
  }

  //At this point, we have at least 1 dead Combatant and at least 1 revival move!
  return {
    actionModel: randomFromArray(revivalActions),
    targetModel: randomFromArray(deadCombatants),
  }


}


/*
 RECOVER
 -> Do I have an HP move? //preserves the items for people who don't have these abilities
 -> Do I have an HP item?
 -> Am I SELF serving or TEAM serving (personality setting)
 */


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-recover-path.js